import { useTheme } from '@emotion/react'

export const GoogleIcon = () => {
  const theme = useTheme()

  return (
    <svg viewBox="0 0 27 30" xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem">
      <path
        d="M.221.877l14.122 14.124L.221 29.124a2.529 2.529 0 01-.097-.704V1.58c0-.262.038-.495.097-.703zm25.745 12.9c.614.348.965.794.965 1.224 0 .43-.353.875-.965 1.224l-5.536 3.144-4.369-4.368 4.37-4.37 5.535 3.145zM1.073 29.988l14.13-14.13 4.133 4.134L2.3 29.671c-.46.261-.878.364-1.227.318zm18.262-19.98l-4.133 4.133L1.072.012C1.415-.037 1.84.067 2.3.33l17.035 9.679z"
        fill={theme.arcadeColors.semantic.iconInverse}
        fillRule="evenodd"
      />
    </svg>
  )
}
